import { useEffect } from 'react';
import { useBillContext } from '../context/BillContext';

const BillInitializer = ({ children }: { children: React.ReactNode }) => {
  const { refreshBills } = useBillContext();

  useEffect(() => {
    void refreshBills();
  }, [refreshBills]);

  return <>{children}</>;
};

export default BillInitializer;
